import type { FC, ReactNode } from 'react';
import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { NavigationSurface } from '@/navigation/components/NavigationSurface';
import type { NavigationItemProps } from '@/navigation/types/navigation';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    container: {
      backgroundColor: theme.colors.tertiaryContainer,
      borderRadius: 20,
      marginHorizontal: 16,
      marginVertical: 8,
      overflow: 'hidden'
    },
    contentWrapper: { paddingHorizontal: 16, paddingVertical: 8 },
    header: { color: theme.colors.primary },
    content: { color: theme.colors.primary }
  });

type Props = {
  header: string;
  content?: ReactNode;
} & NavigationItemProps;

export const RefChatMessage: FC<Props> = ({
  header,
  content,
  ...navItemProps
}) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <NavigationSurface style={styles.container} elevation={0} {...navItemProps}>
      <View style={styles.contentWrapper}>
        <Text variant="titleMedium" style={styles.header}>
          {header}
        </Text>
        {content && (
          <Text variant="bodyLarge" style={styles.content}>
            {content}
          </Text>
        )}
      </View>
    </NavigationSurface>
  );
};
